import React from 'react';
import data from '../resources/rtiact.json'
import Table from '../components/table';

const Rtiact = () => {  
    return (
      <div className="App">
        <h1 style={{
                borderBottom: '2px solid rgb(109, 169, 228)',
                display: 'inline-block',
                marginTop: '45px'
            }}>RTI Acts</h1>
        <Table data={data} text={'View'}/>
      </div>
    );
  };
  
  export default Rtiact;